import React, { Component } from 'react';
import { connect } from "react-redux";
import PlayButton from 'components/user/PlayButton.js';
import StepSequencer from 'components/v2/StepSequencer.js';
import ContextualHelpComponent from 'components/sidebar/ContextualHelpComponent.js';

class MiniTrackComponent extends Component {
    play() {
        this.props.sequencerEngine.play();
    }

    render() {
        return (
            <div className="mini-sequencer">
            <StepSequencer
              disablePianoRoll={true}
              disableTab={true}
              disableDelete={true}
              alreadyLoaded={this.props.sequencerEngine !== undefined}
              scriptingInput={this.scriptingInput}
              hideLFOsTrack={true}
              hideSends={true}
              sequencerEngine={this.props.sequencerEngine}
              selectedTrack={this.props.sequencerEngine.cursor.track}
              stretchTracks={false}
              history={this.props.history}
              onSelectTrack={(i) => this.onSelectTrack(i)}
              keyboardEngine={this.keyboardEngine}
              focusScripting={() => this.focusScripting()}
              onAddSound={(soundId, layerMode, slice, chord) => []}
              hideSequencer={false}
              />
             <div className="play-container">
                <PlayButton isPlaying={this.props.isPlaying} play={() => this.play()}/>
                <ContextualHelpComponent/>
              </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.getSequenceId();
    return {
        isPlaying: state.sequencer.isPlaying[id] || false,
        resolution: state.sequencer.displayResolution,
    };
};
 
export default connect(mapStateToProps, undefined)(MiniTrackComponent);

